import AmplitudeTaskParameters from 'models/Amplitude/AmplitudeTaskParameters'
import { API_URL, fetchOptions, parseJSONContent } from 'store/fetchUtils'
import { useAnalytics } from './useAnalytics'

const useTaskService = () => {
	// const currentOpenedTask = useRecoilValue(openedTask)
	const { dispatchAnalyticsEvent } = useAnalytics()

	const cancelTask = (data, justification, i18n, pushNotification) => {
		return fetch(
			`${API_URL}/api/tasks/${data.id}/cancel`,
			fetchOptions({
				method: 'PUT',
				body: { justification },
			})
		)
			.then((r) => {
				parseJSONContent(r)
				pushNotification(undefined, 'success', i18n`Task cancelled!`)
				dispatchAnalyticsEvent(
					'cancelTask',
					AmplitudeTaskParameters.fromJSON(data)
				)
			})
			.catch((e) => {
				pushNotification(undefined, 'error', e.message)
			})
	}
	return { cancelTask }
}

export default useTaskService
